import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n/config'; // 在最开始导入i18n配置
import i18n from './i18n/config';
import axios from 'axios';
import App from './App';
import './index.css';
import './styles/Buttons.css';

// 配置axios全局默认值和拦截器
axios.interceptors.request.use(
  (config) => {
    // 确保headers对象存在
    if (!config.headers) {
      config.headers = {};
    }
    
    // 添加当前语言到请求头
    const currentLanguage = i18n.language || localStorage.getItem('language') || 'zh';
    config.headers['Accept-Language'] = currentLanguage;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);